import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-plant-topology',
  templateUrl: './plant-topology.component.html'
})
export class PlantTopologyComponent {
  isThisSectionVisible = false;

  toggleVisibility() {
    console.log(this.isThisSectionVisible);
    this.isThisSectionVisible = !this.isThisSectionVisible;
  }

  @Input()
  parentForm!: FormGroup;

  @Output()
  openHelpModal: EventEmitter<any> = new EventEmitter();

  constructor() {}
}
